module.exports = __webpack_public_path__ + "openai-logo-b4e007ea9db719d324b2cddfb75be396.png";